import { SET_PERMISSIONS } from "./actionTypes";

const initialState={ permissions: JSON.parse(localStorage.getItem("authUser")) ?.response?.permissions || [] };

const permissions=(state=initialState,action)=>{
  switch(action.type){
    case SET_PERMISSIONS:
      return {
        ...state,
        permissions:action.payload || []
      };

    default:
      return state;
  }
};

export default permissions;